module.exports = __webpack_public_path__ + "static/media/6.ffd35a93.jpeg";